/*File made for Utility functions only e.g. isObjectEmpty*/
export function isObjectEmpty(obj){
    if (typeof obj !== 'object' || obj === null) {
        return true;
    }
    return Object.keys(obj).length === 0;
}

export function objectHasEntry(obj) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    return Object.keys(obj).length > 0;
}

export function checkArrayVal(array){
    if(array && typeof array ){
        return array
    }
    return [];
}

export function isArrayEmpty(arr){
    if(!Array.isArray(arr)){
        console.error('The passed in argument is not an array');
    }
    return (Array.isArray(arr) && arr.length === 0)
}

//checks if antd form is missing values, ignore fields are the fields that the function doesn't check.
export const isFormMissingValues = (fieldsValue, ignoreFields) => {
    for (const [key, value] of Object.entries(fieldsValue)) {
        if (value === undefined || (typeof value === 'string' && value === '')) {
            if (ignoreFields && ignoreFields.length > 0 && ignoreFields.includes(key)) {
                continue;
            }
            return true;
        }
    }
    return false;
}

export const reIndexArray = (array = [], reIndexProps = [])=>{
    if(array.length === 0){
        console.warn('no entries to reindex');
    }

    return array.map((item, idx)=>{
        const updatedObj = {index:idx};
        if(reIndexProps.length > 0){
            reIndexProps.forEach((prop)=>{
                updatedObj[prop] = idx;
            })
        }
        return {...item, ...updatedObj};
    });
}

export const swapItemsInArray = (array, index1, index2) => {
    const newArray = [...array];

    if (index1 < 0 || index1 >= newArray.length || index2 < 0 || index2 >= newArray.length) {
        console.error('Invalid index provided for swap operation.');
        return newArray; // Return the copy unchanged
    }

    // Swap using destructuring
    [newArray[index1], newArray[index2]] = [newArray[index2], newArray[index1]];

    return newArray;
};

export const formatQuestionAnswerTime = (totalSeconds) => {
    const seconds = Math.max(0, totalSeconds),
        totalMinutes = seconds / 60,
        roundedMinutes = Math.round(totalMinutes * 2) / 2,
        unit = (roundedMinutes === 1.0) ? 'min' : 'mins',
        displayValue = Number.isInteger(roundedMinutes) ? roundedMinutes : roundedMinutes.toFixed(1);
    return `${displayValue} ${unit}`;
};

export function formatYearText(inputText) {
    // A regular expression to dynamically capture the two parts:
    // 1. ^([a-zA-Z]+): Captures one or more letters at the start (e.g., "YEAR").
    // 2. (\d+)$: Captures one or more digits at the end (e.g., "10").
    const regex = /^([a-zA-Z]+)(\d+)$/;

    // Use String.prototype.replace() for a clean solution
    const formattedText = inputText.replace(regex, (match, wordPart, numberPart) => {
        // 1. Format the word part to Title Case:
        //    - Convert the whole word to lowercase.
        //    - Capitalize the very first character.
        const titleCaseWord = wordPart.charAt(0).toUpperCase() + wordPart.slice(1).toLowerCase();

        // 2. Return the word and number parts joined by a space.
        return `${titleCaseWord} ${numberPart}`;
    });

    return formattedText;
}

export const mergeReactRefs = (...refs) => {
    return (node) => {
        refs.forEach((ref) => {
            if (typeof ref === 'function') {
                ref(node);
            } else if (ref != null) {
                ref.current = node;
            }
        });
    };
};